module.exports = __webpack_public_path__ + "img/report-6.db486a43.jpg";